export const videoCategories = [
  {
    slug: 'mingxing-bagua',
    name: '明星八卦',
    icon: 'ri-star-smile-line',
    count: 1286,
    description: '娱乐圈最新爆料，明星私生活大起底',
    color: 'primary',
  },
  {
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    icon: 'ri-user-smile-line',
    count: 953,
    description: '网红圈翻车实录，人设崩塌现场',
    color: 'accent',
  },
  {
    slug: 'baozou-shipin',
    name: '暴走视频',
    icon: 'ri-fire-line',
    count: 742,
    description: '高能名场面合集，看完直呼好家伙',
    color: 'secondary',
  },
  {
    slug: 'neimu-dagua',
    name: '内幕大瓜',
    icon: 'ri-spy-line',
    count: 611,
    description: '圈内人爆料，一手内幕消息',
    color: 'primary',
  },
];

export const hotVideos = [
  {
    id: 'v001',
    title: '某顶流小生深夜密会神秘女子，酒店共度8小时',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20paparazzi%20style%20night%20scene%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20dim%20streetlights%20and%20silhouettes%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20dark%20tones%2C%20noir%20aesthetic%2C%20high%20contrast%20photography%20with%20deep%20shadows%20and%20isolated%20light%20sources&width=800&height=450&seq=video-cover-001&orientation=landscape',
    category: '明星八卦',
    views: '128.6万',
    comments: 3842,
    publishTime: '2026-06-28',
    isHot: true,
    isNew: false,
    duration: '08:24',
  },
  {
    id: 'v002',
    title: '知名带货网红翻车！被扒售卖假货证据确凿',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20scattered%20luxury%20cosmetics%20and%20products%20on%20a%20dark%20surface%20with%20dramatic%20side%20lighting%2C%20counterfeit%20goods%20theme%2C%20mysterious%20atmosphere%2C%20high%20contrast%20shadows%2C%20noir%20style%2C%20deep%20dark%20background&width=800&height=450&seq=video-cover-002&orientation=landscape',
    category: '网红黑料',
    views: '96.3万',
    comments: 2156,
    publishTime: '2026-06-27',
    isHot: true,
    isNew: false,
    duration: '12:58',
  },
  {
    id: 'v003',
    title: '某女星综艺现场发飙摔话筒，导演组紧急叫停',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20TV%20studio%20set%20with%20spotlight%20and%20microphone%20on%20floor%2C%20tense%20atmosphere%2C%20low%20key%20lighting%2C%20cinematic%20mood%2C%20behind%20the%20scenes%20aesthetic%2C%20dark%20surroundings%20with%20single%20dramatic%20light%20beam&width=800&height=450&seq=video-cover-003&orientation=landscape',
    category: '明星八卦',
    views: '215.8万',
    comments: 8921,
    publishTime: '2026-06-27',
    isHot: true,
    isNew: false,
    duration: '05:37',
  },
  {
    id: 'v004',
    title: '内部人员爆料：某综艺节目黑幕操作曝光',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20office%20scene%20with%20confidential%20documents%20on%20a%20desk%20under%20dim%20desk%20lamp%2C%20whistleblower%20theme%2C%20leaked%20information%20vibe%2C%20noir%20filmmaking%20style%2C%20deep%20shadows%2C%20moody%20atmosphere&width=800&height=450&seq=video-cover-004&orientation=landscape',
    category: '内幕大瓜',
    views: '187.2万',
    comments: 5634,
    publishTime: '2026-06-26',
    isHot: false,
    isNew: true,
    duration: '15:42',
  },
  {
    id: 'v005',
    title: '某男团成员被拍到与女经纪人亲密互动',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20night%20street%20scene%20with%20two%20shadowy%20figures%20walking%20closely%20together%2C%20paparazzi%20long%20lens%20style%2C%20grainy%20texture%2C%20low%20light%20urban%20setting%2C%20suspenseful%20mood%2C%20noir%20photography&width=800&height=450&seq=video-cover-005&orientation=landscape',
    category: '明星八卦',
    views: '76.5万',
    comments: 1892,
    publishTime: '2026-06-26',
    isHot: false,
    isNew: true,
    duration: '06:15',
  },
  {
    id: 'v006',
    title: '网红圈大地震！多位头部主播涉嫌税务问题',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20ominous%20scene%20with%20stacks%20of%20paper%20money%20and%20documents%20on%20a%20dark%20table%2C%20dramatic%20top%20lighting%2C%20financial%20scandal%20theme%2C%20noir%20aesthetic%2C%20deep%20contrast%20shadows&width=800&height=450&seq=video-cover-006&orientation=landscape',
    category: '网红黑料',
    views: '342.1万',
    comments: 12567,
    publishTime: '2026-06-25',
    isHot: true,
    isNew: false,
    duration: '18:33',
  },
];

export const weeklyRanking = [
  { rank: 1, title: '某顶流小生深夜密会神秘女子', views: '128.6万', trend: 'up' },
  { rank: 2, title: '网红圈税务风波持续发酵', views: '342.1万', trend: 'up' },
  { rank: 3, title: '综艺节目黑幕操作全曝光', views: '187.2万', trend: 'up' },
  { rank: 4, title: '知名带货网红售假实锤', views: '96.3万', trend: 'down' },
  { rank: 5, title: '某女星综艺现场发飙名场面', views: '215.8万', trend: 'up' },
  { rank: 6, title: '男团成员与经纪人关系成谜', views: '76.5万', trend: 'new' },
  { rank: 7, title: '选秀节目投票造假被举报', views: '55.2万', trend: 'up' },
  { rank: 8, title: '某歌手新歌被指抄袭海外作品', views: '89.4万', trend: 'down' },
];

export const testimonials = [
  {
    id: 't1',
    name: '吃瓜一线猹',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20moody%20portrait%20of%20anonymous%20person%20in%20shadow%2C%20half%20face%20visible%2C%20mysterious%20vibe%2C%20low%20key%20lighting%2C%20noir%20style%20headshot%2C%20dramatic%20side%20light&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    content: '这个站真的太狠了，每天凌晨蹲更新！比微博热搜真实一百倍，好多料都是这里首发然后才上热搜的。建议加个推送功能，不然半夜刷不到新瓜睡不着觉！',
    badge: '黑料元老',
    date: '2026-06-27',
  },
  {
    id: 't2',
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20portrait%20of%20anonymous%20silhouette%2C%20profile%20view%2C%20dramatic%20lighting%20from%20below%2C%20noir%20aesthetic%2C%20deep%20shadows%2C%20moody%20atmosphere&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    content: '之前在一个大V那里看到推荐过来的，结果一刷就是三个小时…料太猛了，而且更新速度真的快。有些视频在其他平台根本看不到，懂的都懂。',
    badge: '铁杆瓜友',
    date: '2026-06-26',
  },
  {
    id: 't3',
    name: '瓜田守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20anonymous%20portrait%20with%20face%20obscured%20by%20shadow%2C%20mysterious%20mood%2C%20low%20key%20portrait%20photography%2C%20noir%20style%2C%20dramatic%20single%20light%20source&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    content: '全网最真实的娱乐八卦平台没有之一！评论区也很有趣，瓜友们个个都是人才，说话又好听。每天上班摸鱼必刷，已经推荐给全公司了哈哈。',
    badge: '瓜田活跃用户',
    date: '2026-06-25',
  },
];

export const featuredComment = {
  content: '黑料视频就是娱乐圈的照妖镜。在这里，没有公关洗白，没有资本控评，只有最原始最真实的爆料。每一个视频都是一把揭开虚伪面具的刀。',
  author: '匿名业内人士',
  role: '前娱乐记者 / 10年从业经验',
};

export const siteStats = {
  totalVideos: '12,847',
  dailyUpdate: '35+',
  onlineUsers: '128,562',
  totalComments: '2,847,391',
};